import React from "react";
import { Actions } from "../../core/modules/Actions";
import { ModuleEvents } from "./Actions";
import { onToast } from "../../core/Constant";
import { navigateTo, goBack } from "../../core/services/NavigationServicd";
// import {navigate} from '../../core/repository/Repository';

export default {
  [ModuleEvents.UPDATE_STUDENT_STATUS]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.students.getAdminUserDetails({ type: 2 }));
    onToast("Student Status", payload, false);
  },

  [ModuleEvents.CREATE_ADMIN_STUDENT]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.students.getAdminUserDetails({ type: 2 }));
    onToast("Student Status", payload, false);
  },

  [ModuleEvents.CREATE_ADMIN_STUDENT_BY_COURSE]: ({
    dispatch,
    payload,
    appState,
  }) => {
    dispatch(Actions.students.getAdminUserDetails({ type: 2 }));
    onToast("Student Status", payload, false);
    navigateTo(-1);
  },

  [ModuleEvents.RESET_COURSE_PROGRESS]: ({ dispatch, payload, appState }) => {
    onToast("Course Progress Reset", payload, false);
  },

  [ModuleEvents.UPDATE_STUDENT]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.students.getAdminUserDetails({ type: 2 }));
    onToast("Update Student", payload, false);
  },

  [ModuleEvents.UPDATE_STUDENT_ENROLLMENT]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.students.getAdminUserDetails({ type: 2, search: payload?.stdSearchQuery || "" }));
    onToast("Update Student Enrollment", payload, false);
  },

  [ModuleEvents.DELETE_STUDENT_REVIEWS]: ({ dispatch, payload, appState }) => {
    dispatch(Actions.students.getAdminUserDetails({ type: 2 }));
    onToast("Delete Student", payload, false);
  },
};
